module.exports = __webpack_public_path__ + "static/media/techSheets.6e2aa909.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/techSheets.png
// module id = 997
// module chunks = 0